import React from "react";
import DataVizChart from "./DataVizChart";
import DataVizHeading from "./DataVizHeading";
import { tools } from "/data/tools";
import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/dist/ScrollToPlugin";

import "../css/styles.css";

const keys = {
  Rarely: "Rarely",
  Sometimes: "Sometimes",
  Often: "Often",
  NotAtALL: "Not At All",
  Somewhat: "Somewhat",
  VeryMuch: "Very Much",
};
class DataVizTools extends React.Component {
  constructor(props) {
    super(props);
    this.boxWidth = 100;
    this.boxHeight = 100;
    this.boxOffset = 10;
    this.corners = [
      "lowerLeftCorner",
      "lowerRightCorner",
      "upperRightCorner",
      "upperLeftCorner",
    ];
  }

  positionTip = (e, box) => {
    let y = e.clientY + (window.pageYOffset || document.body.scrollTop) + 5;
    let x = e.clientX;

    if (window.innerWidth < x + this.boxWidth + this.boxOffset) {
      box.style.left = x - (this.boxWidth + 25 + this.boxOffset) + "px";
    } else {
      box.style.left = x + this.boxOffset + "px";
    }
    if (e.clientY < this.boxHeight) {
      box.style.top = y + this.boxOffset + "px";
    } else {
      box.style.top = y - this.boxHeight - this.boxOffset + "px";
    }

    if (
      window.innerWidth < x + this.boxWidth + this.boxOffset &&
      e.clientY < this.boxHeight
    ) {
      this.box.classList.add("upperRightCorner");
    } else if (
      window.innerWidth < x + this.boxWidth + this.boxOffset &&
      e.clientY > this.boxHeight
    ) {
      this.box.classList.add("lowerRightCorner");
    } else if (
      window.innerWidth > x + this.boxWidth + this.boxOffset &&
      e.clientY < this.boxHeight
    ) {
      this.box.classList.add("upperLeftCorner");
    } else {
      this.box.classList.add("lowerLeftCorner");
    }
  };

  showTip = (e, content) => {
    if (!this.attached) {
      this.box.append(content);
      this.box.style.display = "block";
      this.attached = true;
    }
    this.box.style.width = this.boxWidth;
    this.box.style.height = this.boxHeight;
    this.positionTip(e, this.box);
  };

  hideTip = () => {
    this.attached = false;
    this.box.removeChild(document.getElementById("textNode"));
    this.corners.map((corner) => {
      this.box.classList.remove(corner);
    });

    this.box.style.display = "none";
  };

  makeContent = (dimension, vals) => {
    let content = document.createElement("div");
    let header = document.createElement("h3");
    let title = dimension === "Freq" ? "FREQUENCY" : "LIKEABILITY";
    header.append(title);
    content.append(header);
    for (let obj in vals) {
      let line = document.createElement("div");
      line.classList.add("line");
      let key = document.createElement("span");
      key.classList.add("key");
      key.append(keys[obj] + ": ");
      line.append(key);
      let val = document.createElement("span");
      val.classList.add("val");
      val.append(vals[obj]);
      line.append(val);
      content.append(line);
      content.id = "textNode";
    }
    return content;
  };

  unHighlightAll = () => {
    const removeHighlight = (objs) => {
      Array.prototype.slice.apply(objs).map((obj) => {
        if (obj.classList.contains("highlight"))
          obj.classList.remove("highlight");
      });
    };
    removeHighlight(document.getElementsByClassName("leaf"));
    removeHighlight(document.getElementsByClassName("bar"));
  };

  setBar = (e) => {
    this.unHighlightAll();
    let bar = e.target.id.substring(0, e.target.id.length - 3);
    let leaf = bar + "Leaf";
    e.target.classList.add("highlight");
    document.getElementById(leaf).classList.add("highlight");
    gsap.to(window, { duration: 1, scrollTo: "#" + leaf });
  };

  setToolTip = (e, tooltip) => {
    let str = tooltip.id;
    let toolname = str.substring(0, str.length - 4);
    let dimension = str.substring(str.length - 4, str.length);
    let content = this.makeContent(dimension, tools[toolname][dimension]);
    this.showTip(e, content);
  };

  unsetListeners = () => {
    let tooltips = document.getElementsByClassName("tooltip");
    let bars = document.getElementsByClassName("bar");
    Array.prototype.slice.apply(tooltips).map((tooltip) => {
      tooltip.removeEventListener("mouseover", (e) => {
        this.setToolTip(e, tooltip);
      });
      tooltip.addEventListener("mouseout", () => this.hideTip());
    });

    Array.prototype.slice.apply(bars).map((bar) => {
      bar.removeEventListener("click", (e) => {
        this.setBar(e);
      });
    });
    document
      .getElementsByTagName("body")[0]
      .removeEventListener("click", (e) => {
        if (e.target.id === "") {
          this.unHighlightAll();
        }
      });
  };

  setListeners = () => {
    let tooltips = document.getElementsByClassName("tooltip");
    let bars = document.getElementsByClassName("bar");
    Array.prototype.slice.apply(tooltips).map((tooltip) => {
      tooltip.addEventListener("mouseover", (e) => {
        this.setToolTip(e, tooltip);
      });
      tooltip.addEventListener("mouseout", () => this.hideTip());
    });

    Array.prototype.slice.apply(bars).map((bar) => {
      bar.addEventListener("click", (e) => {
        this.setBar(e);
      });
    });
    document.getElementsByTagName("body")[0].addEventListener("click", (e) => {
      if (e.target.id === "") {
        this.unHighlightAll();
      }
    });
  };
  componentDidMount() {
    gsap.registerPlugin(ScrollToPlugin);
    this.box = document.createElement("div");
    this.box.classList.add("tip");
    document.body.append(this.box);
    this.setListeners();
  }

  componentWillUnmount() {
    this.unsetListeners();
  }
  render() {
    return (
      <div>
        <div className="app">
          <DataVizChart />
          <footer>
            <div>
              DATA SOURCE:{" "}
              <a
                href="https://drive.google.com/file/d/1h9cjC2ERuPKGV4k4aJMYR88v31Ce5kDb/view"
                target="_blank"
              >
                2022 Survey Data
              </a>
            </div>
            <div className="rightCol">
              Visualization by Steinar Shellenberger
            </div>
          </footer>
        </div>
      </div>
    );
  }
}

export default DataVizTools;
